import { render } from "./ForgotLoader.vue?vue&type=template&id=0fd8f33c"
import script from "./ForgotLoader.vue?vue&type=script&lang=js"
export * from "./ForgotLoader.vue?vue&type=script&lang=js"

import "./ForgotLoader.vue?vue&type=style&index=0&id=0fd8f33c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__